import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { Observable } from 'rxjs/Observable';
import { modalComponent } from '../../../utils/modal/modal.component';
import { MatOptionSelectionChange, MatDialog, MAT_DIALOG_DATA } from '@angular/material'; 
import { utils } from '../../../utils/utils';
import { Direccion } from '../../../models/direccion';
import { Pais } from '../../../models/pais';
import { Estado } from '../../../models/estado';
import { Ciudad } from '../../../models/ciudad';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'my-direccion-addedit',
  styles: [],
  templateUrl: './direccionAddEdit.component.html',
  providers: [generalService]
})

export class direccionAddEditComponent {

  @ViewChild('infiniteSelect') selectElem: MatSelect;
  public titulo = 'Agregar';
  public direccion: Direccion;
  public direccionAgregar: FormGroup;
  public paises: Pais[] = [];
  public estados: Estado[] = [];
  public estadosPorPais: Estado[] = [];
  public ciudades: Ciudad[] = [];
  public ciudadesPorEstado: Ciudad[] = [];
  public filtroCiudades: any[];
  public localidad: any[] = [];
  public localidadesAux: any[] = [];
  public postalCode: any[] = [];
  public postalCodeAux: any[] = [];
  public postalCodeEstado: any[] = [];
  public suburb: any[] = [];
  public suburbAux: any[] = [];
  public codigoPostalAUX: any[] = [];
  
  private isFilteredCp = false;
  private filteredItemsShowCp = 10
  private arrayFilteredCp = undefined;
  private arrayFilteredCpUnit = undefined;
  private itemsShow = 0;
  public matOptions: any;
  timeout: any;
  vistaBtn : boolean;
  constructor(private formBuilder: FormBuilder, 
              private _generalService: generalService, 
              public dialog: MatDialog, 
              public dataService: DataService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.direccion = new Direccion();
    this.direccion.cliente = this.dataService.idCliente;
    this.dataService.guardado = false;
    this.vistaBtn = data.vistaBtn;
  }

  ngOnInit() {
    this.buildForm();
    this.matOptions = new Object();
    this.matOptions.postalCodeMat = [];
    const suburb = this.consultarSuburb();
    
    if(this.dataService.tipo == 'editar') {
      this.consultarDireccion();
    }else{
      this.getData();
    }


    this.selectElem.onOpen.subscribe(() => this.registerPanelScrollEvent());
  }
  registerPanelScrollEvent() {
    const panel = this.selectElem.panel.nativeElement;
    panel.addEventListener('scroll', event => this.loadAllOnScroll(event));
  }
 
  loadAllOnScroll(event) {
     if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight)) {
      if(this.isFilteredCp) {
        if(this.filteredItemsShowCp < this.arrayFilteredCp.length) {
            this.filteredItemsShowCp += 10;
            this.postalCode = this.arrayFilteredCp.slice(0, this.filteredItemsShowCp);
        }
      } else {
        if(this.itemsShow < this.matOptions.postalCodeMat.length) {
          this.itemsShow += 10;
          this.postalCode = this.matOptions.postalCodeMat.slice(0, this.itemsShow);
        }
      }
   }
  }
  getData(){
    const postalCode = this.consultarPostalCode();
    const paises = this.consultarPaises();
    const ciudades = this.consultarCiudades();
    const localidades = this.consultarLocalidad();
    const estados = this.consultarEstados();
    
    
  }

  modal(tipo, mensaje) {
    this.dataService.modal = tipo;
    this.dataService.mensaje = mensaje;
    const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
    this.dataService.dialogModal = dialogModal;
  }

  cerrarModal(nuevaDireccion = null) {
    this.dataService.dialogRef.close(nuevaDireccion);
  }

  buildForm() {
    this.direccionAgregar = this.formBuilder.group({
      alias: this.formBuilder.control(null, [Validators.required, Validators.maxLength(44)]),
      pais: this.formBuilder.control(null, [Validators.required]),
      estado: this.formBuilder.control(null, [Validators.required]),
      ciudad: this.formBuilder.control(null, [Validators.required]),
      LOCATION: this.formBuilder.control(null),
      POSTAL_CODE: this.formBuilder.control(null),
      SUBURB: this.formBuilder.control(null),
      colonia: this.formBuilder.control(null, [Validators.required, Validators.maxLength(99)]),
      calle: this.formBuilder.control(null, [Validators.maxLength(99)]),
      codigo: this.formBuilder.control(null, [Validators.maxLength(19)]),
      numero: this.formBuilder.control(null, [Validators.maxLength(19)]),
    });
  }

  consultarPaises(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall(`direccion/consultarPaises`)
          .subscribe((paises) => {
            if (paises && paises.length > 0) {
              this.paises = paises;
            }

            for (let i = 0; i < this.paises.length; i++) {
              if (this.paises[i].nombre === "México") {
                this.direccion.pais = this.paises[i].idPais; 
              }
            }
            resolve();
          }, (error: any) => {
            console.log(error);
            this._generalService.toastCall(error);
            reject();
          });
    });
  }

  consultarEstados(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall(`direccion/consultarEstados`)
          .subscribe((estados) => {
            if (estados && estados.length > 0) {
              this.estados = estados;
            }
            if(this.dataService.tipo == 'agregar') {
              this.direccion.estado = this.estados[0].idEstado;
              
            }
             
            resolve();
          }, (error: any) => {
            console.log(error);
            this._generalService.toastCall(error);
            reject();
          });
    });
  }

  consultarCiudades(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall(`direccion/consultarCiudades`)
          .subscribe((ciudades) => {
            if (ciudades && ciudades.length > 0) {
              this.ciudades = ciudades;
              this.filtroCiudades = this.ciudades;
            }
            resolve();
          }, (error: any) => {
            console.log(error);
            this._generalService.toastCall(error);
            reject();
          });
    });
  }

  /*
  filtrarEstados(opcion: MatOptionSelectionChange) {
    if (opcion.isUserInput) {
      const idPais = opcion.source.value;

      if (this.direccionAgregar.controls['pais'].value !== idPais) {
        this.direccionAgregar.controls['estado'].setValue(null);
        this.direccionAgregar.controls['ciudad'].setValue(null);
      }
      this.estadosPorPais = this.estados.filter((estado) => estado.idPais === idPais);
      this.ciudadesPorEstado = [];
    }
  }

  filtrarCiudades(opcion: MatOptionSelectionChange) {
    if (opcion.isUserInput) {
      const idEstado = opcion.source.value;

      if (this.direccionAgregar.controls['estado'].value !== idEstado) {
        this.direccionAgregar.controls['ciudad'].setValue(null);
      }
      this.ciudadesPorEstado = this.ciudades.filter((ciudad) => ciudad.idEstado === idEstado);
    }
  }
  */

  filtrarSuburb(opcion: MatOptionSelectionChange){
    if (opcion.isUserInput) {
      const POSTAL_CODE_ID = opcion.source.value;

      if (this.direccionAgregar.controls['POSTAL_CODE'].value !== POSTAL_CODE_ID) {
        this.direccionAgregar.controls['SUBURB'].setValue(null);
  
      }
      this.suburbAux = this.suburb.filter((suburb) => suburb.POSTAL_CODE_ID === POSTAL_CODE_ID);
    }
  }

  onSubmit() {
    let datosDireccion = {
      idCliente: this.direccion.cliente,
      alias: this.direccion.alias,
      idCiudad: this.direccion.ciudad,
      LOCATION_ID: this.direccion.LOCATION,
      POSTAL_CODE_ID: this.direccion.POSTAL_CODE,
      SUBURB_ID: this.direccion.SUBURB,
      colonia: this.direccion.colonia,
      calle: this.direccion.calle,
      codigo: this.direccion.codigo,
      numero: this.direccion.numero
    };

    let tipo = 'agregar';
    let metodo = 'direccion/insertarDireccion/';

    if (this.dataService.tipo == 'editar') {
      tipo = 'editar';
      metodo = 'direccion/actualizarDireccion/' + this.dataService.id;
    }

    this._generalService.metodoCallParamsPutPost(tipo, datosDireccion, metodo, true).subscribe(
        (result) => { 
          if (result != '') {
            this.dataService.mensajeAlert = result;
          } else {
            this.dataService.guardado = true;
          }
          this.cerrarModal(datosDireccion);
        },
        (error) => {
          const errorMsj =  error as any;
          console.log(errorMsj);
        }
    ); 
  }

  consultarDireccion() {
    this._generalService.metodoCallParams(this.dataService.id, 'direccion/consultarDireccion', true)
      .subscribe((result) => {
        this.direccion = result[0];
       

        this._generalService.metodoCall(`direccion/consultarpostalCode`)
        .subscribe((postalCode) => {
          if (postalCode && postalCode.length > 0) {
            this.postalCode = postalCode;//.slice(0, 10); // Limitar a los primeros 10 elementos
            //this.postalCodeAux ;
            this.matOptions.postalCodeMat = postalCode;

            this.setValues();
            this.getData();
           
            
          }
          
        }, (error: any) => {
          console.log(error);
          this._generalService.toastCall(error);
         
        });

      }, 
      (error) => {
        console.log(error);
        this._generalService.toastCall(error);  
    });
  }
  consultarLocalidad(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall(`direccion/consultarLocalidad`)
          .subscribe((localidad) => {
            if (localidad && localidad.length > 0) {
              this.localidad = localidad;
              this.localidadesAux =  this.localidad;
            }

            resolve();
          }, (error: any) => {
            console.log(error);
            this._generalService.toastCall(error);
            reject();
          });
    });
  }
  // consultarPostalCode(): Promise<void> {
  //   return new Promise((resolve, reject) => {
  //     this._generalService.metodoCall(`direccion/consultarpostalCode`)
  //         .subscribe((postalCode) => {
  //           if (postalCode && postalCode.length > 0) {
  //             this.postalCode = postalCode;
  //             this.postalCode = postalCode.slice(0, 10);
  //             this.postalCodeAux =  this.postalCode;
  //             this.matOptions.postalCodeMat = postalCode
  //           }
  //           resolve();
  //         }, (error: any) => {
  //           console.log(error);
  //           this._generalService.toastCall(error);
  //           reject();
  //         });
  //   });
  // }
  consultarPostalCode(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall(`direccion/consultarpostalCode`)
        .subscribe((postalCode) => {
          if (postalCode && postalCode.length > 0) {
            this.postalCode = postalCode;//.slice(0, 10); // Limitar a los primeros 10 elementos
            //this.postalCodeAux ;
            this.matOptions.postalCodeMat = postalCode;


            if(this.dataService.tipo == 'agregar') {
              this.codigoPostalAUX = this.postalCode.filter((element) => element.STATE_ID === this.estados[0].idEstado).slice(0, 10);
              this.postalCodeAux = this.postalCode.filter((element) => element.STATE_ID === this.estados[0].idEstado); 
            }
            
          }
          resolve();
        }, (error: any) => {
          console.log(error);
          this._generalService.toastCall(error);
          reject();
        });
    });
  }
  consultarSuburb(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall(`direccion/consultarSuburb`)
          .subscribe((suburb) => {
            if (suburb && suburb.length > 0) {
              this.suburb = suburb;
            }
            resolve();
          }, (error: any) => {
            console.log(error);
            this._generalService.toastCall(error);
            reject();
          });
    });
  }

  setValues() {
    this.direccionAgregar.controls['alias'].setValue(this.direccion.alias);
    this.direccionAgregar.controls['pais'].setValue(this.direccion.pais);
    this.direccionAgregar.controls['estado'].setValue(this.direccion.estado);
    this.direccionAgregar.controls['ciudad'].setValue(this.direccion.ciudad);
    this.direccionAgregar.controls['LOCATION'].setValue(this.direccion.LOCATION_ID);
    this.direccionAgregar.controls['POSTAL_CODE'].setValue(this.direccion.POSTAL_CODE_ID);
    this.codigoPostalAUX = this.postalCode.filter(element => element.STATE_ID === this.direccion.estado).slice(0, 10);
    // Verificar si this.direccion.POSTAL_CODE_ID cumple con la condición y agregarlo a this.codigoPostalAUX  para que salga en el listado 
    const postalCodeId = this.direccion.POSTAL_CODE_ID;
    if (postalCodeId) {
    const found = this.codigoPostalAUX.find(element => element.POSTAL_CODE_ID === postalCodeId);
    if (!found) {
        const postalCodeDireccion = this.postalCode.find(element => element.POSTAL_CODE_ID === postalCodeId);
        if (postalCodeDireccion) {
            this.codigoPostalAUX.push(postalCodeDireccion);
        }
    }
    }

    this.postalCodeAux = this.postalCode.filter((element) => element.STATE_ID === this.direccion.estado);

    this.direccionAgregar.controls['colonia'].setValue(this.direccion.colonia);
    this.direccionAgregar.controls['calle'].setValue(this.direccion.calle);
    this.direccionAgregar.controls['numero'].setValue(this.direccion.numero);
    this.direccionAgregar.controls['codigo'].setValue(this.direccion.codigo);
    this.direccionAgregar.controls['SUBURB'].setValue(this.direccion.SUBURB_ID);
  }

  filtroCity(val: any) {
    let arr: any[];
    if (val.currentTarget.value != "") {
      arr = this.filtroCiudades.filter((obj) => {
        return obj.nombre.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
      })
    } else {
      arr = this.filtroCiudades;
    }
    this.ciudades = arr;
  }

  filtroLocalidad(val: any) {
    let arr: any[];
    if (val.currentTarget.value != "") {
      arr = this.localidadesAux.filter((obj) => {
        return obj.NAME.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
      })
    } else {
      arr = this.localidadesAux;
    }
    this.localidad = arr;
  }
  

  filtroCp(val: any) {
    if (this.timeout) {
        clearTimeout(this.timeout);
    }

    const searchValue = val.currentTarget.value.trim().toLowerCase();
    this.timeout = setTimeout(() => {
        

      let arr: any[];

      if (searchValue !== "") {
          arr = this.postalCodeAux
              .filter((obj) => obj.NAME.toLowerCase().indexOf(searchValue) > -1)
              .slice(0, 10); // Limitar a los primeros 10 elementos
      } else {
          arr = this.postalCodeAux.slice(0, 10); // Restaurar a los primeros 10 elementos del array original
      }
      
      //console.log("filtroCp: Resultado filtrado:", arr);
      this.codigoPostalAUX = arr;
    }, 300); // Esperar 300 ms antes de ejecutar la búsqueda

    
  }
    
  filtroColonia(val: any){
    let arr: any[];
    if (val.currentTarget.value != "") {
      arr = this.suburbAux.filter((obj) => {
        return obj.NOMBRE.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
      })
    } else {
      arr = this.suburbAux;
    }
    this.suburb = arr;
  }

  setearCodigopOSTAL(event: any){
    this.codigoPostalAUX = this.postalCode.filter((element) => element.STATE_ID === event.value).slice(0, 10);
    this.postalCodeAux = this.postalCode.filter((element) => element.STATE_ID === event.value);
  }

}




// WEBPACK FOOTER //
// ./src/app/cliente-sae/cliente-sae-agregar-editar/direcciones/direccionAddEdit.component.ts